/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconAi = createReactComponent("outline", "ai", "IconAi", [["path", { "d": "M8 16v-6a2 2 0 1 1 4 0v6", "key": "svg-0" }], ["path", { "d": "M8 13h4", "key": "svg-1" }], ["path", { "d": "M16 8v8", "key": "svg-2" }]]);

export { IconAi as default };
//# sourceMappingURL=IconAi.mjs.map
